__turbopack_context__.v({
  "enter": "SampleImagePicker-module-scss-module__X-fYWq__enter",
  "exit": "SampleImagePicker-module-scss-module__X-fYWq__exit",
  "fade-in": "SampleImagePicker-module-scss-module__X-fYWq__fade-in",
  "fade-out": "SampleImagePicker-module-scss-module__X-fYWq__fade-out",
  "fade-out-80": "SampleImagePicker-module-scss-module__X-fYWq__fade-out-80",
  "header": "SampleImagePicker-module-scss-module__X-fYWq__header",
  "headerIcon": "SampleImagePicker-module-scss-module__X-fYWq__headerIcon",
  "headerLabel": "SampleImagePicker-module-scss-module__X-fYWq__headerLabel",
  "slide-in-from-bottom": "SampleImagePicker-module-scss-module__X-fYWq__slide-in-from-bottom",
  "slide-in-from-left": "SampleImagePicker-module-scss-module__X-fYWq__slide-in-from-left",
  "slide-in-from-right": "SampleImagePicker-module-scss-module__X-fYWq__slide-in-from-right",
  "slide-in-from-top": "SampleImagePicker-module-scss-module__X-fYWq__slide-in-from-top",
  "slide-out-to-bottom": "SampleImagePicker-module-scss-module__X-fYWq__slide-out-to-bottom",
  "slide-out-to-left": "SampleImagePicker-module-scss-module__X-fYWq__slide-out-to-left",
  "slide-out-to-right": "SampleImagePicker-module-scss-module__X-fYWq__slide-out-to-right",
  "slide-out-to-top": "SampleImagePicker-module-scss-module__X-fYWq__slide-out-to-top",
  "thumbnail": "SampleImagePicker-module-scss-module__X-fYWq__thumbnail",
  "thumbnailDisabled": "SampleImagePicker-module-scss-module__X-fYWq__thumbnailDisabled",
  "thumbnailImage": "SampleImagePicker-module-scss-module__X-fYWq__thumbnailImage",
  "thumbnailRow": "SampleImagePicker-module-scss-module__X-fYWq__thumbnailRow",
  "thumbnailSelected": "SampleImagePicker-module-scss-module__X-fYWq__thumbnailSelected",
  "wrapper": "SampleImagePicker-module-scss-module__X-fYWq__wrapper",
  "zoom-in": "SampleImagePicker-module-scss-module__X-fYWq__zoom-in",
  "zoom-out": "SampleImagePicker-module-scss-module__X-fYWq__zoom-out",
});
